import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DeltaArrowDown from './icon-delta-arrow-down.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DeltaArrowDown {...validProps} />;
}
SvgComponent.iconName = 'deltaArrowDown';

/**
 * @deprecated This is a legacy icon
 */
export const DeltaArrowDownIcon = svgIconWrapper(SvgComponent);
